import React from 'react';
import { Button } from 'react-bootstrap';
import { FaDownload } from 'react-icons/fa';
import Tabela from '~/Components/TabelaDinamica/Tabela';
import { exportarEmExcel } from '~/Utils/Helpers';

// W-0804 — Grid read-only. Valor (rateio do boleto) só no modo Analítico (RN-06/RN-10).
// Foco=0 (Cobradores) agrupa por cobrador; Foco=1 (Empreendimento) agrupa por empreendimento.
// Sintético = só totais por grupo (qtd de boletos + soma de valor); Analítico = linha por boleto.
// A ordenação base já vem do backend (RN-09).
const fmtData = (v) => (v ? new Date(v).toLocaleDateString('pt-BR') : '');

const fmtValor = (v) =>
  v == null
    ? ''
    : Number(v).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

const nomeCobrador = (l) => {
  const cod = l.prestador != null ? l.prestador : '';
  const nome = l.apelido_cobrador || '';
  if (nome) return `${cod} - ${nome}`;
  return String(cod);
};

const TabelaAcordosNaoConcretizados = ({ linhas, analitico, foco }) => {
  const dadosFonte = linhas || [];

  if (analitico) {
    const colunas = [
      { key: 'prestador', title: 'Cobrador', ordenacao: true },
      { key: 'nome_da_familia', title: 'Empreendimento', ordenacao: true },
      {
        key: 'ql',
        title: 'QL',
        ordenacao: false,
        render: (_v, item) =>
          `${item.mapa1 || ''}${item.mapa1 || item.mapa2 ? '/' : ''}${item.mapa2 || ''}`,
      },
      { key: 'conta_cedente', title: 'Cliente', ordenacao: true },
      { key: 'apelido_conta', title: 'Apelido', ordenacao: true },
      { key: 'boleto', title: 'Boleto', ordenacao: true },
      { key: 'acordo', title: 'Data Acordo', ordenacao: true, render: (v) => fmtData(v) },
      { key: 'data_inat', title: 'Data Inativação', ordenacao: true, render: (v) => fmtData(v) },
      { key: 'valor', title: 'Valor', ordenacao: true, render: (v) => fmtValor(v) },
    ];

    const dados = dadosFonte.map((l, i) => ({
      ...l,
      id: `${l.boleto}-${l.prestador}-${l.conta_cedente}-${i}`,
    }));

    const handleExportar = () => {
      const cabecalho = [
        'Cobrador',
        'Empreendimento',
        'QL',
        'Cliente',
        'Apelido',
        'Boleto',
        'Data Acordo',
        'Data Inativação',
        'Valor',
      ];
      const rows = dadosFonte.map((l) => [
        l.prestador != null ? l.prestador : '',
        l.nome_da_familia || '',
        `${l.mapa1 || ''}${l.mapa1 || l.mapa2 ? '/' : ''}${l.mapa2 || ''}`,
        l.conta_cedente != null ? l.conta_cedente : '',
        l.apelido_conta || '',
        l.boleto != null ? l.boleto : '',
        fmtData(l.acordo),
        fmtData(l.data_inat),
        fmtValor(l.valor),
      ]);
      exportarEmExcel([cabecalho, ...rows], 'acordos-nao-concretizados.csv');
    };

    return (
      <>
        <div className="d-flex justify-content-end mb-2">
          <Button
            variant="outline-primary"
            onClick={handleExportar}
            disabled={dadosFonte.length === 0}
          >
            <FaDownload />
            <span>&nbsp;Exportar Excel</span>
          </Button>
        </div>
        <Tabela colunas={colunas} dados={dados} />
      </>
    );
  }

  // Sintético — totais por grupo (RN-10). Foco define a chave de agrupamento.
  const grupos = {};
  dadosFonte.forEach((l) => {
    const chave =
      foco === 1
        ? l.nome_da_familia || ''
        : `${l.prestador != null ? l.prestador : ''}|${l.apelido_cobrador || ''}`;
    if (!grupos[chave]) {
      grupos[chave] = {
        chave,
        descricao: foco === 1 ? l.nome_da_familia || '' : nomeCobrador(l),
        quantidade: 0,
        total: 0,
      };
    }
    grupos[chave].quantidade += 1;
    grupos[chave].total += l.valor != null ? Number(l.valor) : 0;
  });

  const linhasSintetico = Object.keys(grupos).map((k, i) => ({
    ...grupos[k],
    id: `grupo-${i}`,
  }));

  const colunasSintetico = [
    {
      key: 'descricao',
      title: foco === 1 ? 'Empreendimento' : 'Cobrador',
      ordenacao: true,
    },
    { key: 'quantidade', title: 'Qtd. Boletos', ordenacao: true },
  ];

  const handleExportarSintetico = () => {
    const cabecalho = [foco === 1 ? 'Empreendimento' : 'Cobrador', 'Qtd. Boletos'];
    const rows = linhasSintetico.map((g) => [g.descricao, g.quantidade]);
    exportarEmExcel([cabecalho, ...rows], 'acordos-nao-concretizados-sintetico.csv');
  };

  return (
    <>
      <div className="d-flex justify-content-end mb-2">
        <Button
          variant="outline-primary"
          onClick={handleExportarSintetico}
          disabled={linhasSintetico.length === 0}
        >
          <FaDownload />
          <span>&nbsp;Exportar Excel</span>
        </Button>
      </div>
      <Tabela colunas={colunasSintetico} dados={linhasSintetico} />
    </>
  );
};

export default TabelaAcordosNaoConcretizados;
